module.exports = __webpack_public_path__ + "static/media/umbrella-loader-purplish-blue.94996023.gif";